import axios from "axios";
import Storage from './Storage';

class Http {

    apiUrl: string = process.env.REACT_APP_API_URL || "";
    storage = new Storage();

    constructor() { }

    async get(url: string) {
        return await axios.get(`${this.apiUrl}/${url}`, {
            headers: {
                'Content-Type': "application/json"
            }
        });
    }

    async post(url: string, data: any) {
        return await axios.post(`${this.apiUrl}/${url}`, data, {
            headers: {
                'Content-Type': "application/json"
            }
        });
    }

    async secureGet(url: string) {
        return await axios.get(`${this.apiUrl}/${url}`, {
            headers: {
                'Content-Type': "application/json",
                'Authorization': `Bearer ${this.storage.token()}`
            }
        });
    }

    async securePost(url: string, data: any) {
        return await axios.post(`${this.apiUrl}/${url}`, data, {
            headers: {
                'Content-Type': "application/json",
                'Authorization': `Bearer ${this.storage.token()}`
            }
        });
    }
}

export default Http;